import React, { Fragment } from "react";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';


const SelfSizingTextField = (props) => {
    const initialCountDistplay = `${ props.initialValue ?  props.initialValue.length : 0}/${props.maxSize}`;
    const [characterCountText, setCharacterCountText] = React.useState(initialCountDistplay);

    return (
        <Fragment>
            <TextField
                required={props.required}
                disabled={props.disabled}
                multiline 
                InputLabelProps={{ shrink: true }}
                //if this is uncommented, it will display the character counter under the field           
                //helperText={characterCountText===''?`${ props.initialValue ?  props.initialValue.length : 0}/${props.maxSize}`:characterCountText}
                id={props.id}
                name={props.name}
                label={props.label +' ' +characterCountText}
                placeholder={props.placeholder}
                minRows={1}
                fullWidth
                {...props.register(props.name)}
                onChange={event => {
                    setCharacterCountText(`${ event.target.value ?  event.target.value.length : 0}/${props.maxSize??1000}`); 
                    //call the registered onChange to allow default behaviour
                    props.register(props.name).onChange(event);
                }}
                error={props.errors ? true : false}
            />
            <Typography variant="inherit" color="error.main">
                {props.errors?.message}
            </Typography>
        </Fragment>
    );
}
export default SelfSizingTextField;